import * as yup from "yup";

const DEFAULT_MSG = "Este campo es requerido."

const adSchema = yup.object().shape({
    title: yup.string().required(DEFAULT_MSG),
    type: yup.string().required(DEFAULT_MSG),
    desktop_code: yup.string(),
    desktop_attachment: yup.number(),
    desktop_link: yup.string(),
    mobile_code: yup.string(),
    mobile_attachment: yup.number(),
    mobile_link: yup.string(),
    app_code: yup.string(),
    app_attachment: yup.number(),
    app_link: yup.string(),
});

export {
    adSchema
}